import { createLexicon } from "@itaas/core/composition";

export type { LexiconKey, ProductContext } from "@itaas/core/composition";

/** Lexique métier Hospitol — libellés shell vs modules sources. */
export const t = createLexicon("hospitol");
